export interface BulkCreateFinancialYearRequestDto {
    companyIds: string[];
}
